/**
 * API origin. Development uses the local backend; production retains the live default.
 * For local development against a local backend, set in .env.local:
 *   REACT_APP_API_BASE_URL=http://localhost:5002
 */
export const API_ORIGIN =
  process.env.REACT_APP_API_BASE_URL?.trim().replace(/\/+$/, "").replace(/\/api\/v1$/, "") ||
  (process.env.NODE_ENV === "development" ? "http://localhost:5002" : "https://navoapi.viaspark.site");

/** Axios baseURL — all admin routes live under /api/v1/admins/ on dev */
export const API_V1_ADMIN_BASE = `${API_ORIGIN}/api/v1/admins/`;

/**
 * Where setupProxy forwards /uploads (see src/setupProxy.js).
 * Use production host when local disk has no upload files but DB points at prod paths.
 */
export const MEDIA_PROXY_TARGET =
  process.env.REACT_APP_MEDIA_PROXY_TARGET || API_ORIGIN;
